import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Compass, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/translations';
import './Header.css';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();
  const t = useTranslation(language);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToSection = (id) => {
    setIsMobileMenuOpen(false);
    
    // If not on homepage, navigate first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation and then scroll
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Already on homepage, just scroll
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <Compass size={32} />
          <span className="logo-text">Just Travel</span>
        </Link>

        <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <a onClick={() => scrollToSection('destinations')} className="nav-link">{t('nav.destinations')}</a>
          <a onClick={() => scrollToSection('calculator')} className="nav-link">{t('nav.calculator')}</a>
          <a onClick={() => scrollToSection('packing')} className="nav-link">{t('nav.packing')}</a>
          <a onClick={() => scrollToSection('blog')} className="nav-link">{t('nav.blog')}</a>
          <a onClick={() => scrollToSection('lounges')} className="nav-link">{t('nav.lounges')}</a>
          <a onClick={() => scrollToSection('about')} className="nav-link">{t('nav.about')}</a>
        </nav>

        <div className="header-actions">
          <button 
            className="language-btn"
            onClick={toggleLanguage}
            aria-label="Change Language"
          >
            <Globe size={20} />
            <span>{language === 'de' ? 'EN' : 'DE'}</span>
          </button>

          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
